/*       */

import { gql } from '@apollo/client';
import loadWorkspaceDetailsCommonQuery from 'graphql/workspaces/loadWorkspaceDetailsCommonQuery';

export default gql`
    mutation addWorkspaceClassResourcesMutation($id: ID!, $classes: [ID]!) {
        result: workspaceAddClassResources(id: $id, classes: $classes) {
            ${loadWorkspaceDetailsCommonQuery}
        }
    }
`;
